// 根据语言返回不同的语录数据
export const slogenCardsDataByLang = {
  zh: [
    {
      icon: '/image/符号1.png',
      text: '大规模发钱补贴生育\n短期来看，有助于扩大内需、稳增长、稳就业\n长期来看，有助于增强中国经济发展的信心\n提升中国的创新力和竞争力，维持民族长盛不衰',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '孩子是当前中国经济最好的投资\n中国正面临生育率下降、消费疲软、产能过剩等问题\n恰恰可以通过给有孩子的家庭发钱来刺激经济\n形成一举两得的效果',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '中国已经进入物质全面充裕唯缺孩子的时期 \n中国什么都不缺，就缺孩子',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '由于女性是生育的主体，所以 \n一个生育友好的社会，必须也是一个女性友好的社会',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '建议取消中考，淡化高考 \n缩短中小学学制，普及大学通识教育',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '创新是经济发展的第一推动力\n创新力=人口数量×人口能力×（内部交流量+外部交流量）',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '在AI时代，创新力的重要性将日益凸显\n生命的意义要更加重视人性，而人性就是创新和传承',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    }
  ],
  zh_TW: [
    {
      icon: '/image/符号1.png',
      text: '中國已經進入物質全面充裕唯缺孩子的時期\n中國什麼都不缺，就缺孩子',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '由於女性是生育的主體，所以\n一個生育友好的社會，必須也是一個女性友好的社會',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '建議取消中考，淡化高考\n縮短中小學學制，普及大學通識教育',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '孩子是當前中國經濟最好的投資\n中國正面臨生育率下降、消費疲軟、產能過剩等問題\n恰恰可以透過資助有孩子的家庭來刺激經濟\n形成一舉兩得的效果',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '大規模資助並補胋生育\n短期來看，有助於擴大內需、穩增長、穩就業\n長期來看，有助於增強中國經濟發展的信心\n提升中國的創新力與競爭力，維持民族長盛不衰',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '創新是經濟發展的第一推動力\n創新力＝人口數量×人口能力×（內部交流量＋外部交流量）',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: '在AI時代，創新力的重要性將日益凸顯\n生命的意義要更加重視人性，而人性就是創新和傳承',
      author: '-- 梁建章',
      image: '/image/老板照片-压缩.png'
    }
  ],
  en: [
    {
      icon: '/image/符号1.png',
      text: 'Children represent the best investment in China\'s current economy.\nFacing challenges like declining fertility rates, sluggish consumption, and industrial overcapacity, the nation can effectively address these issues through direct subsidies to families with children. \n—simultaneously revitalizing the economy and achieving dual outcomes.',
      author: '-- James Liang',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: 'Large-scale financial incentives to support childbearing will, in the short term, help boost domestic demand, stabilize growth, and sustain employment;\nin the long term, they will strengthen confidence in China\'s economic development,\nenhance the country\'s innovation capacity and competitiveness, and ensure the nation\'s enduring prosperity.',
      author: '-- James Liang',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: 'Innovation is the primary driver of economic development.\n \n Innovation strength = population size × avarage competence × (internal interaction volume + external interaction volume).',
      author: '-- James Liang',
      image: '/image/老板照片-压缩.png'
    },
    {
      icon: '/image/符号1.png',
      text: 'As we enter the AI era, the importance of innovative capacity will become ever more prominent.\nThe pursuit of life\'s meaning necessitates heightened focus on human nature—defined fundamentally by innovation and intergenerational continuity.',
      author: '-- James Liang',
      image: '/image/老板照片-压缩.png'
    }
  ]
};

